"use client";

import { css } from "styled-system/css";
import { flex, stack } from "styled-system/patterns";

import { Skeleton } from "@/components/skeleton";
import { range } from "@/utils/range";

export function AnnouncementsLoading() {
  return (
    <div className={stack({ gap: "0", flex: "1", w: "full" })}>
      {range(0, 3).map((i) => (
        <div key={i} className={css({ px: "20", py: "24", position: "relative" })}>
          <div className={flex({ gap: "16", alignItems: "flex-start" })}>
            <Skeleton
              className={css({ w: "12", h: "12", m: "4", rounded: "full", flexShrink: 0 })}
            />
            <div className={timelineVerticalLineStyles} />
            <div className={stack({ gap: "8", flex: "1" })}>
              <div className={stack({ gap: "4" })}>
                <div
                  className={flex({
                    w: "full",
                    gap: "4",
                    justify: "space-between",
                    align: { base: "flex-start", desktop: "center" },
                    direction: { base: "column", desktop: "row" },
                  })}
                >
                  <Skeleton className={css({ h: "20", w: "[280px]" })} />
                  <div className={flex({ gap: "4" })}>
                    {i === 0 && (
                      <Skeleton className={css({ h: "20", w: "[40px]", rounded: "200" })} />
                    )}
                    <Skeleton className={css({ h: "20", w: "[80px]", rounded: "200" })} />
                  </div>
                </div>
                <Skeleton className={css({ h: "16", w: "[66px]" })} />
              </div>

              <div className={stack({ gap: "4", w: "full", maxW: "[695px]" })}>
                <Skeleton className={css({ h: "16", w: "full" })} />
                <Skeleton className={css({ h: "16", w: "full" })} />
                <Skeleton className={css({ h: "16", w: "[40%]" })} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

const timelineVerticalLineStyles = css({
  position: "absolute",
  left: "[30px]",
  transform: "translateX(-50%)",
  top: "[44px]",
  h: "[calc(100% - 20px)]",
  w: "1",
  bg: "skeleton",
});
